import React, { useState, useCallback, useRef, forwardRef, useImperativeHandle, useEffect } from 'react';
import { Tooltip, message } from 'antd';
import { Box, Flex } from 'reflexbox';
import { Virtuoso } from 'react-virtuoso';
import { useHistory } from 'react-router-dom';
import { agentStore, useConvTag } from '@laigu/store';

const { useAgents } = agentStore;

import { getAgentInfoById } from '@laigu/utils/get-agent';

import useUpgrade from '../../../../hooks/use-upgrade';
import handleStream from '../../handleStream';
import ConvSummary from '../../../conv-summary';
import Message from '../../../message';
import useStream from './modules/use-stream';
import QuickBtns from '../quick-btn';
//获取url上的type参数
import { parseUrl } from '@laigu/utils';

import style from './index.less';

const copyContent = content => {
  if (!document.queryCommandSupported('copy')) return;
  const textarea = document.createElement('textarea');
  textarea.innerText = content;
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand('copy');
  document.body.removeChild(textarea);
};

const withdrawTypes = ['text', 'rich_text', 'photo', 'hybrid'];
const hasSummaryEventType = [
  'switch_human',
  'end_conv_timeout',
  'end_conv_agent',
  'end_conv_baidu_robot',
  'end_conv_client'
];
const emptyFun = () => null;

const getSummaryData = ({ centerConv, tagList, agentListAll }) => {
  const convInfo = centerConv;
  let convInfoProps = {
    convTags: [],
    // 对话小结的内容
    content: undefined
  };
  if (convInfo) {
    convInfoProps = {
      ...convInfoProps,
      ...convInfo
    };
    const { agent_id, convTags } = convInfoProps;
    if (convTags) {
      convInfoProps.convTags = convTags.map(convId => tagList.find(val => val.id === convId)).filter(val => val);
    }
    if (agent_id) {
      convInfoProps.agent = getAgentInfoById(agentListAll, agent_id);
    }
  }
  return convInfoProps;
};

const StreamItem = forwardRef((props, ref) => {
  const { bindPackage } = useUpgrade();
  const { me: meInfo } = useAgents();
  const {
    data,
    handleConvTag,
    createConvSummary,
    updateConvSummary,
    handleReEdit,
    handleAddClue,
    handleImageStream,
    handleWithdrawMessage,
    handleTranslateMessage,
    handleRemindMessage,
    handleClickRemindMessage,
    handleEnd,
    handleTop,
    loadMoreBeforeCom,
    loadMoreAfterCom,
    containerId,
    handleSpeechToTxt,
    handleGptSummary,
    handleIntelligentRecommend
  } = props;
  const {
    streams = [],
    centerConvs,
    msgWithdraw,
    productCardFunc,
    clueCollection,
    convCreateOn,
    agentListAll,
    summaryAddable,
    summaryEditable,
    convTagEditable,
    highlightMsg,
    translateEnabled,
    translateLanguage,
    queryTranslateQuota,
    trusted,
    convBelongToMe,
    ended = false,
    listType = '',
    source = ''
  } = data;
  const { convTagList } = useConvTag();
  const { streamList, onOpenFold, openList } = useStream(streams);
  const { getQueryString } = parseUrl;
  const history = useHistory();
  const type = getQueryString('type', history.location.search);
  const handleCopyContent = content => {
    copyContent(content);
    message.success('操作成功');
  };

  const virtuoso = useRef(null);

  const [clientHeight, setClientHeight] = useState(10);

  const renderBtns = useCallback(operator_msg => {
    if (!operator_msg?.length) return;
    const operators = operator_msg ?? [];
    if (!operators?.length) return null;
    return operators?.map((res, index) => {
      switch (res.type) {
        case 'copy':
          return (
            <Box key={index} mr='8px'>
              <div onClick={() => handleCopyContent(res.value)} className={style.operatorBtn}>
                {res.name}
              </div>
            </Box>
          );

        case 'call':
          return (
            <Box key={index} mr='8px'>
              <div className={style.operatorBtn}>
                <a href={`tel:${res.value}`}>{res.name}</a>
              </div>
            </Box>
          );

        case 'link':
          return (
            <Box key={index} mr='8px'>
              <div className={style.operatorBtn}>
                <a href={res.value} target='_blank'>
                  {res.name}
                </a>
              </div>
            </Box>
          );
      }
    });
  }, []);

  const renderQuickBtns = useCallback(btns => {
    return btns?.map(btn => {
      return <QuickBtns {...btn}></QuickBtns>;
    });
  }, []);

  const getMessageRow = useCallback(
    stream => {
      const { id: agent_id } = meInfo;

      const { from_type, created_on, id, isLastStream = false, extra = {} } = stream;

      // const productCardData = productCardFunc ? productCard : {};
      const convertStream = handleStream(
        stream,
        {
          // productCard: productCardData
        },
        agentListAll,
        containerId,
        ended,
        listType
      );

      if (!convertStream) return null;

      /*
       * 可撤回判断修改
       * 1. 客服
       *   1.1 fromType == 'agent'
       *   1.2 selfMessage == true
       *   1.3 contentType withdrawTypes
       * 2. 机器人
       *   2.1 fromType == 'bot' （所有机器人消息都可撤回，包括托管和非托管模式）
       */

      const autoMessageTypes = [
        'auto_reply',
        'welcome',
        'promotion',
        'guide',
        'PRIVATE_KEYWORD_REPLY',
        'COMMENT_FOLLOW_FOLLOWERS',
        'AUTO_FOLLOW_FOLLOWERS',
        'BATCH_SEND_PLAN'
      ];
      const is_truested = convertStream.fromType === 'bot' || autoMessageTypes.includes(convertStream.msgType);

      const withdrawEnable =
        msgWithdraw.status === 'open' &&
        ((convertStream.fromType === 'agent' &&
          convertStream.selfMessage &&
          withdrawTypes.includes(convertStream.contentType)) ||
          convertStream.fromType === 'bot' ||
          autoMessageTypes.includes(convertStream.msgType)) &&
        convertStream.msgType !== 'internal';

      const data = {
        ...convertStream,
        clueCollection: clueCollection && from_type === 'client',
        msgWithdraw: {
          withdrawEnable,
          timeout: msgWithdraw.timeout,
          is_truested
        },
        translateEnabled,
        translateLanguage,
        queryTranslateQuota,
        trusted,
        convBelongToMe,
        isLastStream,
        conversation_id: stream.conversation_id,
        track_id: stream.track_id,
        source
      };

      const onload = isLastStream ? scrollToEnd : emptyFun;
      const highlightFlag = highlightMsg[id];
      const operator_msg = data?.extra?.operator_msg;
      const quickBtns = data?.extra?.quick_btn;

      return (
        <>
          <Message
            data={data}
            key={`${created_on}_${id}`}
            handleReEdit={handleReEdit}
            highlightFlag={highlightFlag}
            onLoad={onload}
            clickFailIcon={emptyFun}
            handleAddClue={bindPackage(handleAddClue, 'clue_collection')}
            handleImageStream={handleImageStream}
            handleWithdrawMessage={handleWithdrawMessage}
            handleTranslateMessage={handleTranslateMessage}
            handleRemindMessage={handleRemindMessage}
            handleClickRemindMessage={handleClickRemindMessage}
            handleSpeechToTxt={handleSpeechToTxt}
            handleGptSummary={handleGptSummary}
            handleIntelligentRecommend={handleIntelligentRecommend}
          />
          {operator_msg?.length ? (
            <Flex flexWrap='wrap' justifyContent='end' mb='16px'>
              {renderBtns(operator_msg)}
            </Flex>
          ) : null}

          {quickBtns?.length ? (
            <Flex flexWrap='wrap' justifyContent='end' pb='16px' style={{ gap: 8 }}>
              {renderQuickBtns(quickBtns)}
            </Flex>
          ) : null}
        </>
      );
    },
    [
      handleReEdit,
      handleAddClue,
      handleImageStream,
      handleWithdrawMessage,
      handleGptSummary,
      handleTranslateMessage,
      handleRemindMessage,
      handleClickRemindMessage,
      convCreateOn,
      productCardFunc,
      translateEnabled,
      translateLanguage,
      queryTranslateQuota,
      trusted,
      agentListAll,
      handleSpeechToTxt,
      ended,
      listType,
      handleIntelligentRecommend
    ]
  );

  const scrollToEnd = useCallback(() => {
    setTimeout(() => {
      virtuoso.current &&
        virtuoso.current.scrollToIndex({
          index: streamList.length,
          behavior: 'auto',
          align: 'start'
        });
    }, 50);
  }, [streamList]);

  const BorderLine = () => (
    <div className={style.divider}>
      <div className={style.line} />
      <ul className={style.dot}>
        <li />
        <li />
        <li />
      </ul>
      <div className={`${style.line} right`} />
    </div>
  );

  const handleScroll = useCallback(e => {
    handleEnd(e.scrollTop + e.clientHeight >= e.scrollHeight - 10);
    handleTop(e.scrollTop === 0);
  });

  useImperativeHandle(ref, () => {
    return {
      scrollToBottom: scrollToEnd,
      scrollToItem: index => {
        virtuoso.current &&
          virtuoso.current.scrollToIndex({
            index,
            behavior: 'auto',
            align: 'start'
          });
      },
      scrollToTop: () => {
        setTimeout(() => {
          virtuoso.current &&
            virtuoso.current.scrollToIndex({
              index: 0,
              behavior: 'auto',
              align: 'start'
            });
        }, 50);
      },
      resizeDomByHeight: resize
    };
  });
  /*
   * 动态计算显示的高度
   * 计算防抖
   * 如果当前在页面的最下面需要滚动到最下面
   * 1. 滚轮在最下面
   * 2. 滚轮滚动到了其他位置
   * 3. 顾客界面和访客卡片特殊处理
   *  含有customer_、clientCard_、undefined 直接 height为400
   * 4. 每个界面对应的会话的容器id
   *  1. 历史 historyPanel
   *  2. 质检 inspectionPanel
   *  3. 黑名单 blacklistPanel
   *
   */
  const resize = useCallback(() => {
    const isExtra = ['customer_', 'clientCard_'];
    const height = containerId
      ? !isExtra.some(extra => containerId.includes(extra))
        ? document.getElementById(containerId)
          ? document.getElementById(containerId).clientHeight
          : document.getElementById('containerElement').clientHeight
        : 400
      : document.getElementById('containerElement')
      ? document.getElementById('containerElement').clientHeight
      : 400;

    setClientHeight(height - 9.5);
  }, []);

  useEffect(() => {
    window.addEventListener('resize', resize);
    return () => {
      window.removeEventListener('resize', resize);
    };
  }, []);

  useEffect(() => {
    resize();
  }, [containerId]);

  /*
   * 可能会出现多余的处理的情况
   */
  const getItem = stream => {
    const { created_on, id, action, type, children, foldId } = stream;

    if (type === 'fold' && children.length) {
      const childrenEle = [];
      children.forEach(steam => {
        childrenEle.push(getMessageRow(steam));
      });
      return (
        <div
          id={foldId}
          className={`${style.fold_row} ${style.messageBox} ${openList.includes(foldId) ? style.open : ''}`}
        >
          <Tooltip title={'点击展开'}>
            <div
              className={`${style.fold_btn} ${children.length > 2 ? style.big : ''}`}
              onClick={() => onOpenFold(foldId)}
            >
              {`已折叠${children.length}条自动消息`}
            </div>
          </Tooltip>
          <div className={style.fold_list}>{childrenEle}</div>
        </div>
      );
    }

    if (hasSummaryEventType.includes(action)) {
      const { target_id } = stream;
      const convInfo = getSummaryData({
        stream,
        centerConv: centerConvs[target_id],
        tagList: convTagList,
        agentListAll
      });
      return (
        <>
          <ConvSummary
            key={`${created_on}_${id}_summary`}
            convInfo={convInfo}
            summaryAddable={summaryAddable}
            summaryEditable={summaryEditable}
            convTagEditable={convTagEditable}
            convId={target_id}
            handleConvTag={tag => handleConvTag(tag, target_id)}
            createConvSummary={(content, successCb) => createConvSummary({ content, convId: target_id, successCb })}
            updateConvSummary={(content, successCb) => updateConvSummary({ content, convId: target_id, successCb })}
          />
          <div className={style.messageBox}>{getMessageRow(stream)}</div>
        </>
      );
    }

    return <div className={style.messageBox}>{getMessageRow(stream)}</div>;
  };

  const minHeight = type ? undefined : clientHeight;
  return (
    <Virtuoso
      style={{ minHeight }}
      firstItemIndex={0}
      initialTopMostItemIndex={streamList.length}
      data={streamList}
      itemContent={(index, stream) => {
        const { showDol = false } = stream;

        return (
          <>
            {showDol && <BorderLine />}
            {getItem(stream)}
          </>
        );
      }}
      followOutput='auto'
      defaultItemHeight={120}
      ref={virtuoso}
      onScroll={e => handleScroll(e.target)}
      components={{
        Footer: () => loadMoreAfterCom,
        Header: () => loadMoreBeforeCom
      }}
      overscan={{ main: 5, reverse: 0 }}
    />
  );
});

export default StreamItem;
